import { Component, Input, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { BackEndService } from 'src/app/services/backend.service'

@Component({
    template: '',
    standalone: true
})
export class ArticleEmbedCommon implements OnInit {
    private searchService = inject(BackEndService)

    @Input() articleid: string = '0'
    @Input() data: string = ''

    public articleResult$: Observable<any> = new Observable<any>()
    public contentSet = ''

    async ngOnInit(): Promise<void> {

        let articleResultInitialised = false
        if (this.data) {
            try {
                const json = atob(this.data)
                const articleResult = JSON.parse(json)
                this.articleResult$ = new Observable<any>((subscriber) => {
                    subscriber.next({
                        articles: [articleResult]
                    })
                    subscriber.complete()
                })
                articleResultInitialised = true
            } catch (e) {

            }
        }

        if (!articleResultInitialised) {
            const [articleID, part, subpart] = this.articleid.split(':')
            this.articleResult$ = this.searchService.article(this.contentSet.toString(), parseInt(articleID), {
                part,
                subpart
            })
        }
    }
}